<template>
  <div class="resolutionCalculatorComponent" refs="resolutionCalculatorComponent">
    <el-form :model="formData" ref="ledResolutionCalculatorForm" :rules="formRules" class="common-form resolution-calc-form">
      <el-form-item class="flex!" prop="pitch" label="PITCH">
        <el-input v-model="formData.pitch" @input="handleResolutionPitchChange" type="number" class="el-input-cstm-sm"></el-input>
      </el-form-item>

      <div class="container m-0 p-0 h-[32px] mt-[18px]">
          <div class="flex">
            <div class="w-[69px] p-0">
              <div class="p-0 text-left text-xs text-graphite-grey pt-[6px]">{{'SIZE (MM)'}}</div>
            </div>
            <div class="w-full p-0">
              <div class="container m-0 p-0 h-[32px] pl-[10px]">
                <div class="flex h-[32px]">
                  <div class="w-[94px] p-0">
                    <el-form-item prop="size.width">
                      <el-input v-model="formData.size.width" @input="handleWidthHeightChange" type="number" class="el-input-cstm-sm"></el-input>
                    </el-form-item>
                  </div>
                  <span class="font-light text-[14px] px-[9px] pt-[3px]">{{'X'}}</span>
                  <div class="w-[94px] p-0">
                    <el-form-item prop="size.height">
                      <el-input v-model="formData.size.height" @input="handleWidthHeightChange" type="number" class="el-input-cstm-sm"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </el-form>
  </div>
</template>
<script src="./led-resolution-calculator.js"></script>
<style lang="scss" src="./led-resolution-calculator.scss"></style>
